import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const initPartnersSwiper = () => {
  const blocks = document.querySelectorAll('.wp-block-lb-partners');

  blocks.forEach((section) => {
    const swiperContainer = section.querySelector('.partners-swiper');
    if (!swiperContainer) return;

    let swiperInstance = null;

    const mediaQuery = window.matchMedia('(min-width: 992px)');

    const handleSwiper = (e) => {
      if (e.matches) {
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
      } else {
        if (!swiperInstance) {
          swiperInstance = new Swiper(swiperContainer, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            navigation: {
              nextEl: section.querySelector('.swiper-btn-next'),
              prevEl: section.querySelector('.swiper-btn-prev'),
            },
            breakpoints: {
              576: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
            },
          });
        }
      }
    };

    handleSwiper(mediaQuery);

    mediaQuery.addEventListener('change', handleSwiper);
  });
};

document.addEventListener('DOMContentLoaded', initPartnersSwiper);

if (window.acf) {
  window.acf.addAction('render_block_preview/type=partners', initPartnersSwiper);
}
